<div *ngIf="onEdit; else list">
  <lms-itinerary-translations-editor
    [itinerary]="itinerary"
    (cancel)="cancel()"
    [selectedTranslation]="selectedTranslation"
    [translations]="translations"
    (onUpdateTranslations)="onUpdateTranslations($event)"
  ></lms-itinerary-translations-editor>
</div>
<ng-template #list>
  <lms-itinerary-translations-list
    *ngIf="translations.length > 0"
    [translations]="translations"
    [itinerary]="itinerary"
    (onUpdateTranslations)="onUpdateTranslations($event)"
    (onSelect)="selectTranslation($event)"
  ></lms-itinerary-translations-list>
</ng-template>
